// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aCellDescription-Bom2aCellDescription-module__box--KgVMp {
  display: flex;
  gap: 3px;
  height: 100%;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aCellDescription-Bom2aCellDescription-module__edit--JNUlV {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aPositions/Bom2aPositionsTable/components/Bom2aCellDescription/Bom2aCellDescription.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AACF;AACA;EACE,OAAA;AACF","sourcesContent":[".box {\n  display: flex;\n  gap: 3px;\n  height: 100%;\n}\n.edit {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aCellDescription-Bom2aCellDescription-module__box--KgVMp`,
	"edit": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aCellDescription-Bom2aCellDescription-module__edit--JNUlV`
};
export default ___CSS_LOADER_EXPORT___;
